
import React from "react";
import "./OracleIdentityGovernance.css";
import MenuNavbar from "../../MenuNavbar";
import Floaticons from "../../Floaticons";
import Tabs from "@mui/material/Tabs";
import PropTypes from "prop-types";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import IdentiyAccessManagement from "../IdentityManagement/IdentityandAccessManagement";
import InfrastructureSecurity from "../InfrastructureSecurity/InfrastructureSecurity";
import PlatformSecurity from "../PlatformSecurity/PlatformSecurity";
import CloudSecurity from "../CloudSecurity/CloudSecurity";
import Link from "@mui/material/Link";
import HomeIcon from "@mui/icons-material/Home";
import { Breadcrumbs } from "@material-ui/core";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 4 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function OracleIdentityGovernance() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="banner-container">
        <img
          src="images/SecuritySchools/SailPoint/school-banner.png"
          alt="banner"
          className="banner-img"
        />
        <div className="breadcrumbs-container">
          <Breadcrumbs separator=">" color="#fff">
            <Link
              underline="hover"
              sx={{ display: "flex", alignItems: "center" }}
              color="#fff"
              href="/"
            >
              <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
            </Link>
            ,
            <Link
              underline="hover"
              key="2"
              color="#fff"
              href="/securityLearningFramework"
              // onClick={handleClick}
            >
              Security Learning Framework
            </Link>
            ,
            <Typography key="3" color="#fff">
              Security Schools
            </Typography>
            ,
          </Breadcrumbs>
        </div>
        <div className="banner-content">
          <h1>Security Schools</h1>
          <i>
            Lorem ipsum is a dummy text of the printing and typesetting industry
          </i>
        </div>
        <MenuNavbar />
      </div>
      <Floaticons />
      <div className="breadcrumbLinks">
        <Breadcrumbs separator=">" aria-label="breadcrumb">
          <a className="menu_title" href="/securitySchools">
            <img src="/images/SecuritySchools/Back-button.png" />
            Security Schools and Bootcamps​
          </a>
          {value === 0 ? (
            <a className="menu_title" href="/securitySchools#I&DInitiatives">
              Identity & Access Management
            </a>
          ) : (
            ""
          )}
          {value === 1 ? (
            <a className="menu_title" href="/securitySchools#InfrastructureSecurity">
              Infrastructure Security
            </a>
          ) : (
            ""
          )}
          {value === 2 ? (
            <a className="menu_title" href="/securitySchools#platformsecurity">
              Platform Security
            </a>
          ) : (
            ""
          )}
          {value === 3 ? (
            <a className="menu_title" href="/securitySchools#cloudsecurity">
              Cloud Security
            </a>
          ) : (
            ""
          )}
          <a className="menu_title" href="">
          Oracle Identity Governance
          </a>
        </Breadcrumbs>
      </div>
      <div className="main-container" id="IdentityGovernance">
        <Box className="boxStyles">
          <Box
            sx={{ borderBottom: 0, borderColor: "divider" }}
            className="tabMenuWrap"
          >
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example"
              centered
            >
              <Tab
                label="Identity & Access Management​"
                {...a11yProps(0)}
                className="tabStyles"
              />
              <Tab
                label="Infrastructure Security"
                {...a11yProps(1)}
                className="tabStyles"
              />
              <Tab
                label="Platform Security"
                {...a11yProps(2)}
                className="tabStyles"
              />
              <Tab
                label="Cloud Security"
                {...a11yProps(3)}
                className="tabStyles"
                // href='https://atci.lkm.delivery.accenture.com/ProfessionalSkills/' target='_blank'
              />
            </Tabs>
          </Box>
          <TabPanel className="tabPanelWrap" value={value} index={0}>
            <div className="tabPanel-innerWrapp">
            <div id="Oracle-Objective">
            <div className="Oracle-AboutWrapp">
              <div className="leftImage">
                <img
                  src="images/SecuritySchools/IdentityGovernance​/About-image.png"
                  alt=""
                  className="img-responsive"
                />
              </div>
              <div className="rightContent">
                <h2 className="SP-AboutHeading">
                  About the Oracle Identity Governance
                </h2>
                <p className="marginB">
                Oracle Identity Governance is a solution that provides self-service, compliance, provisioning, and password management services for applications residing on-premise or on the Cloud.</p>
                <p>Oracle Identity Governance overview includes understanding the purpose and major features of the product, the different modes in which it can be deployed, and its interaction with other products, IT systems, and users.</p>
              </div>
            </div>
            <div className="bottomContent">
            <p class="headingWrap"><span>Total Duration: 45 hours</span>
            <p className="iconWrapper">
            <img className="" src="images/SecuritySchools/IdentityGovernance​/Time-Icon.png"/>
            </p>
            </p>
            <div className="row1-bottom-section">
            <p className="boxBorder">
                <span className="bold">Training model :</span> <br></br>
                <span className="light">
                  VILT+ Hands-on + Assessments​
                </span>
            </p>
            
            </div>
           
            </div>
            </div>
            </div>
            <div className="infographicWrap">
            <img className="topicInFocus-image" src="images/SecuritySchools/IdentityGovernance​/Topics-in-focus.png"/>
            </div>
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={1}>
            <InfrastructureSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={2}>
            <PlatformSecurity />
          </TabPanel>
          <TabPanel className="tabPanelWrap" value={value} index={3}>
            <CloudSecurity />
          </TabPanel>
        </Box>
        
      </div>
    </>
  );
}

export default OracleIdentityGovernance;

